// extracted by mini-css-extract-plugin
module.exports = {"toastProvider":"toast-provider_toastProvider__S72Nu"};